module.exports = __webpack_public_path__ + "static/img/dota.ddad430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dota.png
// module id = iCAB
// module chunks = 1